<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Test', apiMethod: 'Tests', form: () => import('../forms/TestForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Labs', value: 'testId', table: () => import('../tables/LabTestsTable') },
                    { text: 'Samples', value: 'testId', table: () => import('../tables/SampleTestsTable') },
                ],
                mainForm: () => import('../forms/TestForm'),
                claimName: 'Tests',
                apiMethod: 'Tests',
            }
        }
    };
</script>
